import type { Emitter } from 'mitt'
import mitt from 'mitt'
import type { EmitterEvents } from '~/types/emitter'

export default defineNuxtPlugin((nuxtApp) => {
  const emitter: Emitter<EmitterEvents> = mitt<EmitterEvents>()
  nuxtApp.vueApp.provide('emitter', emitter)
  nuxtApp.provide('emitter', emitter)
})
